import './FeaturedImage.css';

function FeaturedImage({ src, alt }) {
  if (!src) return null;
  
  return (
    <div className="featured-image">
      <img src={src} alt={alt} />
    </div>
  );
}

export default FeaturedImage;
